<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex max-w-[600px] justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="header-text">Update Insurance Information</h3>
        <p class="mb-4 text-left text-body-color">
          To update your insurance information, please provide the name of your
          insurance agency and their contact information so that we can request
          an updated Certificate of Insurance.
        </p>
        <form-field
          label="Agency Name"
          :value="agency.name"
          placeholder="Enter agency name"
          :on-input="onInput"
          name="name"
        />
        <form-field
          label="Phone Number"
          :value="agency.phoneNumber"
          placeholder="Enter phone number"
          :on-input="onInput"
          type="tel"
          name="phoneNumber"
        />
        <form-field
          label="Email"
          :value="agency.email"
          placeholder="Enter email"
          :on-input="onInput"
          name="email"
          :error="emailError"
        />
        <div
          class="flex w-full flex-col md:flex-row md:flex-row-reverse md:gap-x-2"
        >
          <button-main
            :disabled="errorsExist"
            :is-loading="isLoading"
            @click="submitRequest"
          >
            Submit Request
          </button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Not Now
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import FormField from '@/components/FormField.vue';
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import WordTools from '@/mixins/wordTools';
import { isEmail } from '@/common/validators';
import { formatPhone } from '@/common/validators';

export default {
  name: 'UpdateInsuranceModal',
  components: {
    Modal,
    ButtonMain,
    FormField,
  },
  mixins: [WordTools],
  props: {
    visible: Boolean,
    type: String,
  },
  emits: ['close', 'submit'],
  data() {
    return {
      agency: {
        name: '',
        phoneNumber: '',
        email: '',
      },
      errors: {
        name: true,
        phoneNumber: true,
        email: true,
      },
      emailError: '',
      phoneError: '',
      isLoading: false,
    };
  },
  computed: {
    errorsExist() {
      return (
        Object.values(this.errors).some((el) => el) ||
        !!this.emailError ||
        !!this.phoneError
      );
    },
  },
  methods: {
    isSameEmailAsTheCurrentUser(email) {
      if (this.$store.state.users.currentUser?.email == email) {
        this.emailError =
          'Your certificate must be provided by an insurance agency';
        return true;
      }
      this.emailError = '';
      return false;
    },
    isSamePhoneAsTheCurrentUser() {
      const currentUserPhone = this.$store.state.users.currentUser?.phone_e164;
      // Only enter this option if the user has not configured a telephone - Only for cases of large carriers
      if (!currentUserPhone) return false;

      const find = '-';
      const re = new RegExp(find, 'g');

      const phoneAgency = this.agency.phoneNumber.replace(re, '');
      const phoneWithoutCountryCode = currentUserPhone.substr(
        currentUserPhone.length - 10
      );
      if (phoneWithoutCountryCode == phoneAgency) {
        this.phoneError =
          'Your certificate must be provided by an insurance agency';
        return true;
      }
      this.phoneError = '';
      return false;
    },
    onInput(e) {
      const { name, value } = e.target;

      let val = value;
      if (name === 'name') {
        this.errors.name = !value.length;
      } else if (name === 'email') {
        this.errors.email = !isEmail(value) && !!value.length;
        if (isEmail(value)) {
          this.isSameEmailAsTheCurrentUser(value);
        }
      } else if (name === 'phoneNumber') {
        const formattedValue = formatPhone(value);
        val = formattedValue;
        this.errors.phoneNumber = val.length !== 12;

        if (val.length === 12) {
          this.isSamePhoneAsTheCurrentUser();
        }
      }

      this.agency[name] = val;
    },
    submitRequest() {
      this.$emit('submit', this.agency);
      this.isLoading = true;
    },
  },
};
</script>

<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-4 text-dark-blue;
}
</style>
